import { render, staticRenderFns } from "./VideosEn.vue?vue&type=template&id=71069406&"
import script from "./VideosEn.vue?vue&type=script&lang=js&"
export * from "./VideosEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports